import { useEffect, Modal, Row, Col, FC, useMemo } from 'external/react'

import usePackage from 'context/package-context/hook'

import useFormValidation, {validators} from 'utilities/form-validation'
import ModalAcceptCancelFooter from 'components/ModalAcceptCancelFooter'
import { clearedUserState } from 'types/context/package'
import AddUserForm from './AddUserForm'

const {createRequiredFieldValidation, createEmailValidation} = validators

const addUserValidations = {
	first_name: [createRequiredFieldValidation('first_name')],
	last_name: [createRequiredFieldValidation('last_name')],
	email: [createRequiredFieldValidation('email'), createEmailValidation('email')]
}

type AddUserModalProps = {
	role: 'Student' | 'Tutor'
	onAddUser: (role: string, newUser: any) => void
}

const AddUserModal: FC<AddUserModalProps> = props => {

	const {role, onAddUser} = props
	const {update, state: {modals}} = usePackage()

	const [errors, validate, resetValidations] = useFormValidation(addUserValidations);

	const modal = useMemo(() => modals[`add${role}`], [modals, role]) 

	function handleAddUser () {
		if (!validate(modal, true)) {
			return;
		}
		onAddUser(role, modal)
		handleClose()
	}


	function handleClose() {
		resetValidations()
		update({modals: {[`add${role}`]: {$shallow: clearedUserState}}})
	}


	useEffect(() => { validate(modal, false) }, [modal])

	const roleName = useMemo(() =>  role === 'Student' ? 'Esudiante' : 'Tutor', [role])

    return (
			<Modal show={modal.open} onHide={handleClose} size='lg' centered>
				<Modal.Header closeButton>
					<h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }} >
						Agregar {roleName}
					</h5>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col>
							<AddUserForm role={role} errors={errors}/>
						</Col>
					</Row>
				</Modal.Body>
				<ModalAcceptCancelFooter onCancel={handleClose} onAccept={handleAddUser}/>
			</Modal>
        )
}

export {AddUserModal as default}